import { LeaveOfAbsenceHours, LeaveType, WeekWithHours } from '../../../models'
import { getHoursPatchClearAndPostData } from '../../../redux/absences-ts/absencesHelpers'
import { PzLeaveType } from '../../types/leaveType'
import { FetchResult } from '../FetchResult'
import { NotificationCenterLog } from '../NotificationCenter/NotificationCenter'
import {
    deleteLeaveOfAbsenceHoursApiCall,
    patchLeaveOfAbsenceHoursApiCall,
    postLeaveOfAbsenceHoursApiCall,
} from './LeaveOfAbsenceHourService'

export const updateLeaveOfAbsenceHours = (
    leaveOfAbsenceId: string,
    leaveOfAbsenceHours: LeaveOfAbsenceHours[],
    eventLogTrackerData: NotificationCenterLog,
    weeksWithHours: WeekWithHours[],
    leaveType?: LeaveType | PzLeaveType,
): Promise<FetchResult<any, string>>[] => {
    const data = getHoursPatchClearAndPostData(leaveOfAbsenceHours, weeksWithHours)
    const absenceHoursToClear = [...data.toClear, ...data.toDelete]

    return [
        ...data.toPatch.map(leaveOfAbsenceHour => {
            const weekWithHours = weeksWithHours.find(week => week.weekNumber === leaveOfAbsenceHour.weekNumber)

            return patchLeaveOfAbsenceHoursApiCall(
                leaveOfAbsenceHour.id,
                leaveOfAbsenceId,
                eventLogTrackerData,
                undefined,
                weekWithHours ? weekWithHours.hours : undefined,
                weekWithHours ? weekWithHours.weekNumber : undefined,
                leaveType,
            )
        }),
        ...absenceHoursToClear.map(
            leaveOfAbsenceHourId => patchLeaveOfAbsenceHoursApiCall(
                leaveOfAbsenceHourId,
                leaveOfAbsenceId,
                eventLogTrackerData,
                undefined,
                0,
            ),
        ),
        ...data.toDelete.map(
            leaveOfAbsenceHourId => deleteLeaveOfAbsenceHoursApiCall(
                leaveOfAbsenceHourId,
                eventLogTrackerData,
            ),
        ),
        ...data.toPost.map(
            weekWithHours => postLeaveOfAbsenceHoursApiCall(
                leaveOfAbsenceId,
                eventLogTrackerData,
                weekWithHours.payrollPeriod ? weekWithHours.payrollPeriod.id : undefined,
                weekWithHours.hours ?? undefined,
                weekWithHours.weekNumber,
                leaveType,
            ),
        ),
    ]
}
